<template>
  <div class="step-wrap" :class="{ iframeFontLarge: isInPassport }">
    <template v-if="isCoolingOff">
      <p class="mb-20">
        {{ languages.delResMsg1 }}
      </p>
      <p class="mb-20">
        {{ languages.gameName }}{{ this.submitForm.gameName }}
      </p>
      <p class="mb-20">
        {{ languages.gameAccount }}{{ this.loginAccount
        }}<span
          class="link j-copy-account ml-20 copy"
          @click="copyAccount"
          :data-clipboard-text="loginAccount"
          >{{ languages.copyAccountInfo }}</span
        >
      </p>
      <p class="mb-20 red" v-html="languages.delResMsg2"></p>
      <p class="mb-20 time">
        {{ languages.delResMsg3
        }}<span class="red"
          ><van-count-down
            ref="countDown"
            :time="time"
            :format="timeFormat"
            :auto-start="false"
        /></span>
      </p>
      <p class="mb-20">
        {{ languages.delResMsg4 }}
      </p>
      <div class="btn-wrap mb-60">
        <van-button class="btn" block type="info" @click="jumpRecoveryPage">
          {{ languages.smartOrderContactService }}
        </van-button>
      </div>
    </template>
    <template v-else>
      <p class="mb-20">
        {{ languages.delResMsg5 }}
      </p>
      <p class="mb-20">
        {{ languages.delResMsg6 }}
      </p>
      <p class="mb-20">
        {{ languages.delResMsg7 }}
      </p>
      <p class="mb-20">{{ languages.delResMsg8 }}</p>
      <div class="btn-wrap mb-60">
        <van-button class="btn" block type="info" @click="handleLogout">
          {{ languages.confirm }}
        </van-button>
      </div>
    </template>
  </div>
</template>

<script>
import { stepKey } from '@configs/officialSupport/accountDelete';
import accountDelete from '@mixins/officialSupport/accountDelete';
import bridge from '@utiles/bridge';
import Clipboard from 'clipboard';
import { CountDown } from 'vant';
export default {
  name: 'deleteResult',
  mixins: [accountDelete],
  data() {
    return {
      choose: 1,
      compKey: stepKey.deleteResult,
      time: 14 * 24 * 60 * 60 * 1000
    };
  },
  watch: {
    step(newVal) {
      if (newVal == this.compKey) {
        this?.$refs?.countDown?.start();
      }
    }
  },
  computed: {
    timeFormat() {
      const langTime = {
        'zh-CN': 'DD天 HH小时 mm分',
        'zh-TW': 'DD天 HH小時 mm分',
        'en-US': 'DD days, HH hours, and mm minutes'
      };
      if (langTime[this.curLang]) {
        return langTime[this.curLang];
      }
      return langTime['en-US'];
    }
  },
  methods: {
    copyAccount() {
      if (bridge.runInsdk()) {
        bridge.callSdkMethod('copyText', {
          content: this.loginAccount
        });
      } else {
        const clipboard = new Clipboard('.j-copy-account');
        clipboard.on('success', e => {
          this.$toast(this.languages.hasCopy);
          e.clearSelection();
        });
        clipboard.on('error', _e => {});
      }
    }
  },
  components: {
    CountDown
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialSupport/workTempForm.scss';
@import '@assets/scss/officialSupport/accountDelete.scss';
.time {
  display: flex;
  flex-wrap: wrap;
  ::v-deep .van-count-down {
    color: red;
    font-size: inherit;
  }
}
.copy {
  text-decoration: underline;
  cursor: pointer;
}
</style>
